import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import React from 'react';
import { Avatar, Tooltip } from 'antd';
import styled from '@xstyled/styled-components';
import { UserAvatar } from './avatar.component';
import { jsx as _jsx } from "react/jsx-runtime";
var Group = Avatar.Group;
var AvatarGroupStyled = styled(Group)(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
export var UserGroupAvatar = function UserGroupAvatar(props) {
  var size = props.size,
      avatars = props.avatars,
      maxCount = props.maxCount,
      maxPopoverPlacement = props.maxPopoverPlacement,
      style = props.style;
  return /*#__PURE__*/_jsx(AvatarGroupStyled, {
    size: size,
    maxCount: maxCount || 3,
    maxPopoverPlacement: maxPopoverPlacement,
    style: style,
    children: avatars.map(function (avatar, index) {
      return /*#__PURE__*/_jsx(Tooltip, {
        title: avatar.alt,
        placement: "top",
        children: /*#__PURE__*/_jsx(UserAvatar, {
          alt: avatar.alt,
          src: avatar.src
        }, index)
      }, index);
    })
  });
};